import { FormControl, FormGroup, Grid, Switch, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { Box } from '@mui/system';
import { Link } from 'react-router-dom';
import { Grupo } from '../../types/grupo/Grupo';
import configUrls from '../../config/configUrls';
import { TipoProcesso } from '../../types/tipoProcesso/TipoProcesso';



type Props = {
    data: TipoProcesso,
    isdisabled?: boolean,
    isLoading?: boolean,
    handleSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
    handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function TipoProcessoForm({
    data,
    isdisabled = false,
    isLoading = false,
    handleSubmit,
    handleChange,
}: Props) {

    return (
        <Box mt={2} p={2}>

            <form onSubmit={handleSubmit} method='POST'>

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                required
                                label="Nome"
                                name="nome"
                                disabled={isdisabled}
                                onChange={handleChange}
                                size="small"
                                inputProps={{ maxLength: 255 }}
                                value={data.nome} />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                required
                                label="Descrição"
                                name="descricao"
                                disabled={isdisabled}
                                onChange={handleChange}
                                size="small"
                                inputProps={{ maxLength: 255 }}
                                value={data.descricao} />

                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <Box display="flex" gap={2}>

                            <Button
                                type="submit"
                                variant="contained"
                                color="secondary"
                                disabled={isdisabled}
                            >
                                Gravar
                            </Button>

                            <Button
                                variant="contained"
                                component={Link}
                                to={configUrls.TIPO_PROCESSO_LIST_RT}
                            >
                                Voltar
                            </Button>
                        </Box>
                    </Grid>
                </Grid>

            </form>



        </Box>
    )
}